// Installs `window.timeline`, the public API for the Konva timeline. Other
// modules (keyboard shortcuts, iframe remote, player) use this to control
// zoom/scroll/seek without holding a Svelte component reference. The shim is
// installed when the Konva timeline mounts and torn down on unmount.

import {
    zoomIn as viewportZoomIn,
    zoomOut as viewportZoomOut,
    setZoom as viewportSetZoom,
    scrollToTime,
    centerOnTime,
    viewportState
} from "./viewport.svelte.js";
import {
    addTrack as addAdditionalTrack,
    removeTrack as removeAdditionalTrack
} from "@app/store/timelineTracksStore.svelte.js";

let installed = false;

/**
 * Install the global shim. Idempotent: calling twice is a no-op.
 */
export function installTimelineGlobals() {
    if (installed || typeof window === "undefined") return;
    installed = true;

    window.timeline = {
        zoomIn(anchorX) { viewportZoomIn(anchorX); },
        zoomOut(anchorX) { viewportZoomOut(anchorX); },
        setZoom(pxPerSec, anchorX) { viewportSetZoom(pxPerSec, anchorX); },
        seek(timeSec) {
            if (window.player && Number.isFinite(timeSec)) {
                window.player.currentTime = timeSec;
            }
        },
        scrollToTime(timeSec, opts) { scrollToTime(timeSec, opts); },
        centerOnTime(timeSec) { centerOnTime(timeSec); },
        addTrack(eventGroupIndex, primaryIndex) {
            addAdditionalTrack(eventGroupIndex, primaryIndex);
        },
        removeTrack(eventGroupIndex) {
            removeAdditionalTrack(eventGroupIndex);
        },
        get pxPerSec() { return viewportState.pxPerSec; },
        get scrollX() { return viewportState.scrollX; }
    };
}

/**
 * Remove the global shim (call on unmount).
 */
export function uninstallTimelineGlobals() {
    if (!installed || typeof window === "undefined") return;
    installed = false;
    delete window.timeline;
}
